<template>
  <b-modal
    :id="modalId"
    size="lg"
    hide-footer
    title="Detalhes do Usuário"
  >
    <div class="p-2">
      <!-- Header com Avatar e Informações -->
      <div class="d-flex align-items-center mb-3">
        <b-avatar
          :src="dados.avatar"
          size="120px"
          rounded
          class="mr-3"
        />
        <div>
          <h4 class="mb-0">{{ `${dados.nome} ${dados.sobrenome}` }}</h4>
          <p class="text-muted mb-1">{{ displaySocialHandle }}</p>
          <b-badge variant="light-primary" class="text-capitalize">
            {{ afiliadoData.categoria || 'Categoria não informada' }}
          </b-badge>
        </div>
      </div>

      <!-- Estatísticas -->
      <div class="d-flex justify-content-between align-items-start mb-3">
        <!-- Estatísticas -->
        <div class="d-flex align-items-center">
          <div v-if="!isVendedor" class="mr-4">
            <h5 class="mb-0">{{ afiliadoData.seguidores }}</h5>
            <small class="text-muted">Seguidores</small>
          </div>
          <!-- <div>
            <h5 class="mb-0"></h5>
            <h5 class="mb-0">{{ afiliadoData.vendasUltimoMes }}</h5>
            <small class="text-muted">Vendas no último mês</small>
          </div> -->
        </div>

        <!-- Redes Sociais -->
        <div class="d-flex align-items-center">
          <a
            v-if="afiliadoData.instagram"
            v-b-tooltip.hover
            :href="'https://instagram.com/' + afiliadoData.instagram"
            class="mr-2"
            title="Instagram"
            target="_blank"
          >
            <feather-icon
              icon="InstagramIcon"
              size="20"
              class="text-primary"
            />
          </a>
          <a
            v-if="afiliadoData.youtube"
            v-b-tooltip.hover
            :href="afiliadoData.youtube"
            class="mr-2"
            title="YouTube"
            target="_blank"
          >
            <feather-icon
              icon="YoutubeIcon"
              size="20"
              class="text-primary"
            />
          </a>
          <a
            v-if="afiliadoData.twitter"
            v-b-tooltip.hover
            :href="'https://twitter.com/' + afiliadoData.twitter"
            title="X (Twitter)"
            target="_blank"
          >
            <feather-icon
              icon="TwitterIcon"
              size="20"
              class="text-primary"
            />
          </a>
        </div>
      </div>

      <!-- Tabs -->
      <b-tabs>
        <b-tab title="Biografia" active>
          <h6 class="font-weight-bold">Sobre {{ dados.nome }}</h6>
          <p class="text-muted">
            {{ afiliadoData.biografia || 'Nenhuma biografia disponível.' }}
          </p>
          <div class="mt-3">
            <h6 class="font-weight-bold">Especialidades</h6>
            <div class="d-flex flex-wrap">
              <b-badge
                v-for="(esp, index) in afiliadoData.especialidades"
                :key="index"
                variant="light-secondary"
                class="mr-1 mb-1"
              >
                {{ esp }}
              </b-badge>
            </div>
          </div>
        </b-tab>
        <b-tab
          v-if="grupo === 1"
          title="Contato"
        >
          <div class="mt-2">
            <p><strong>Email:</strong> {{ dados.email || 'Não informado' }} {{grupo}}</p>
            <p><strong>Telefone:</strong> {{ dados.telefone || 'Não informado' }}</p>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal, BAvatar, BBadge, BTabs, BTab, BSpinner,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getUserData } from '@/auth/utils'

export default {
  name: 'UserProfileModal',
  components: {
    BModal,
    BAvatar,
    BBadge,
    BTabs,
    BTab,
    BSpinner,
  },
  props: {
    modalId: {
      type: String,
      default: 'user-profile-modal',
    },
  },
  data() {
    return {
      dados: { // Mudando de userData para dados para manter consistência
        nome: '',
        email: '',
        telefone: '',
        avatar: null,
      },
      afiliadoData: {
        biografia: '',
        especialidades: [],
        instagram: '',
        youtube: '',
        twitter: '',
        seguidores: 0,
        vendasUltimoMes: 0,
      },
      loading: false,
      grupo: getUserData().id_grupousuario,
      isVendedor: false,
    }
  },
  computed: {
    displaySocialHandle() {
      if (this.afiliadoData.instagram) {
        return `@${this.afiliadoData.instagram}`
      }
      if (this.afiliadoData.youtube) {
        return this.afiliadoData.youtube
      }
      if (this.afiliadoData.twitter) {
        return `@${this.afiliadoData.twitter}`
      }
      if (this.afiliadoData.tiktok) {
        // Assumindo que tiktok também seja um handle
        return `@${this.afiliadoData.tiktok}`
      }
      return 'Rede social não informada' // Mensagem padrão se nenhuma for encontrada
    },
  },
  mounted() {
    this.$root.$on('user-modal-opened', this.handleUserModalOpened)
  },
  beforeDestroy() {
    // Remove o listener quando o componente é destruído
    this.$root.$off('user-modal-opened', this.handleUserModalOpened)
  },
  methods: {
    async handleUserModalOpened(userId) {
      try {
        this.loading = true
        // Busca dados do usuário
        const { data: user } = await axios.get(`/users/${userId}`)
        this.dados = {
          nome: user.cliente.nome,
          sobrenome: user.sobrenome,
          email: user.login,
          telefone: user.celular,
          avatar: user.foto_perfil,
        }

        this.isVendedor = (user.id_grupousuario === 5)

        // Busca dados do afiliado
        if (user.id_grupousuario === 4) {
          const { data: afiliado } = await axios.get(`/afiliado/user/${userId}`)
          this.afiliadoData = {
            biografia: afiliado.biografia,
            especialidades: afiliado.especialidades || [],
            instagram: afiliado.instagram,
            youtube: afiliado.youtube,
            twitter: afiliado.twitter,
            tiktok: afiliado.tiktok,
            categoria: (afiliado.categoria) ? afiliado.categoria.nome : 'Não informada',
            seguidores: afiliado.seguidores || 0,
          }
        }
        if (user.id_grupousuario === 5) {
          const { data: afiliado } = await axios.get(`/vendedor/user/${userId}`)
          this.afiliadoData = {
            biografia: afiliado.biografia,
            especialidades: afiliado.especialidades || [],
            instagram: afiliado.instagram,
            youtube: afiliado.youtube,
            twitter: afiliado.twitter,
            tiktok: afiliado.tiktok,
            categoria: (afiliado.categoria && afiliado.categoria.nome) ? afiliado.categoria.nome : 'Não informada',
            seguidores: afiliado.seguidores || 'Não informado',
          }
        }

        this.afiliadoData.vendasUltimoMes = Math.floor(Math.random() * 151)
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao carregar dados',
            text: 'Não foi possível carregar as informações do usuário',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        console.error('Erro ao buscar dados:', error)
      } finally {
        this.loading = false // Desativando loading
      }
    },
  },
}

</script>

<style lang="scss" scoped>
.modal-profile {
  .banner {
    height: 150px;
    background: linear-gradient(90deg, #5a67d8, #667eea);
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }

  .user-info {
    display: flex;
    flex-direction: column;

    h4 {
      font-size: 1.8rem;
      font-weight: bold;
      color: #2d3748;
      margin: 0;
    }

    p {
      font-size: 1rem;
      color: #718096;
      margin: 0;
    }

    .stats {
      margin-top: 1rem;

      div {
        text-align: center;

        h6 {
          font-size: 1.2rem;
          font-weight: bold;
          margin: 0;
        }

        small {
          font-size: 0.9rem;
          color: #a0aec0;
        }
      }
    }
  }

  .tab-content {
    padding: 1rem 0;

    h6 {
      font-size: 1.2rem;
      font-weight: bold;
      color: #4a5568;
    }

    p {
      font-size: 1rem;
      color: #718096;
    }

    .badge {
      font-size: 0.9rem;
      padding: 0.5rem 1rem;
      background-color: #edf2f7;
      color: #4a5568;
      border-radius: 0.5rem;
      margin-right: 0.5rem;
      margin-bottom: 0.5rem;
    }
  }

  .b-avatar {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
}
</style>
